import { useContext, useSyncExternalStore } from 'react';
import { ReactReduxContext } from 'react-redux';
import { entitySnapshot, entityPreferenceSessionForStore } from './useEntityPreference';
import { hasKnownEntityId, hasKnownShowIdentity } from '../utils/entityIdentity';

export const isFollowedEntity = (kind, entity, state, user) => {
    if (!entity || (kind === 'speaker' && !hasKnownEntityId(entity.id))) return false;
    const snapshot = entitySnapshot(kind, entity, state, user);
    const knownIdentity = kind === 'speaker' ? hasKnownEntityId(entity.id) : hasKnownShowIdentity(entity, snapshot.source);
    return knownIdentity && snapshot.status === true;
};

const guestUser = { authenticated: false };
const emptyPreferences = { mutations: {}, savedShows: {} };
const subscribeToNothing = () => () => {};
const guestSnapshot = () => guestUser;
const emptySnapshot = () => emptyPreferences;

// Identity images also render in signed-out/static previews without a store.
// Within the app, share the Follow controls' pending changes and rollback.
export default function useFollowedEntities() {
    const store = useContext(ReactReduxContext)?.store;
    const session = store ? entityPreferenceSessionForStore(store) : null;
    const state = useSyncExternalStore(session?.subscribe || subscribeToNothing, session?.getSnapshot || emptySnapshot);
    const user = useSyncExternalStore(store?.subscribe || subscribeToNothing, store ? () => store.getState().user : guestSnapshot);
    return (kind, entity) => isFollowedEntity(kind, entity, state, user);
}

export const followedSpeakersFirst = (speakers, isFollowed, preferredSpeakerId) => {
    const preferred = [];
    const followed = [];
    const remaining = [];
    speakers.forEach(speaker => {
        if (preferredSpeakerId && speaker.id === preferredSpeakerId) preferred.push(speaker);
        else if (isFollowed(speaker)) followed.push(speaker);
        else remaining.push(speaker);
    });
    return [...preferred, ...followed, ...remaining];
};
